import { createActionTypeModel } from "../../../../store/global/action-model";


export const GET_BOOKING = 'GET_BOOKING';
export const GET_BOOKING_LIST = 'GET_BOOKING_LIST';
export const FETCH_BOOKING = 'FETCH_BOOKING';
export const FETCH_BOOKING_LIST = 'FETCH_BOOKING_LIST';
export const SET_BOOKING = 'SET_BOOKING';
export const SET_BOOKING_LIST = 'SET_BOOKING_LIST';
export const INSERT_BOOKING = 'INSERT_BOOKING';
export const INSERT_BOOKING_LIST = 'INSERT_BOOKING_LIST';
export const UPDATE_BOOKING = 'UPDATE_BOOKING';
export const UPDATE_BOOKING_LIST = 'UPDATE_BOOKING_LIST';
export const DELETE_BOOKING = 'DELETE_BOOKING';
export const DELETE_BOOKING_LIST = 'DELETE_BOOKING_LIST';

// SELECTED_BOOKING Action Types

export const GET_SELECTED_BOOKING = 'GET_SELECTED_BOOKING';
export const FETCH_SELECTED_BOOKING = 'FETCH_SELECTED_BOOKING';
export const SET_SELECTED_BOOKING = 'SET_SELECTED_BOOKING';
export const SET_SELECTED_BOOKING_AUTONOMOUSE = 'SET_SELECTED_BOOKING_AUTONOMOUSE';
export const INSERT_SELECTED_BOOKING = 'INSERT_SELECTED_BOOKING';
export const UPDATE_SELECTED_BOOKING = 'UPDATE_SELECTED_BOOKING';
export const DELETE_SELECTED_BOOKING = 'DELETE_SELECTED_BOOKING';

// BOOKING_DETAILS_FLAG Action Types

export const SET_BOOKING_DETAILS_FLAG = 'SET_BOOKING_DETAILS_FLAG';
export const TOGGLE_BOOKING_DETAILS_FLAG = 'SET_BOOKING_DETAILS_FLAG';
export const OPEN_BOOKING_DETAILS = 'OPEN_BOOKING_DETAILS';
export const CLOSE_BOOKING_DETAILS = 'CLOSE_BOOKING_DETAILS';

// BOOKING_ARTIST Action Types

export const GET_BOOKING_ARTIST = 'GET_BOOKING_ARTIST';
export const GET_BOOKING_ARTIST_LIST = 'GET_BOOKING_ARTIST_LIST';
export const FETCH_BOOKING_ARTIST = 'FETCH_BOOKING_ARTIST';
export const FETCH_BOOKING_ARTIST_LIST = 'FETCH_BOOKING_ARTIST_LIST';
export const FETCH_BOOKING_ARTIST_LIST_NEXT = 'FETCH_BOOKING_ARTIST_LIST_NEXT';
export const SET_BOOKING_ARTIST_PAGINATION = 'SET_BOOKING_ARTIST_PAGINATION';
export const SET_BOOKING_ARTIST = 'SET_BOOKING_ARTIST';
export const SET_BOOKING_ARTIST_LIST = 'SET_BOOKING_ARTIST_LIST';
export const SET_BOOKING_ARTIST_LIST_LOADING = 'SET_BOOKING_ARTIST_LIST_LOADING';
export const INSERT_BOOKING_ARTIST = 'INSERT_BOOKING_ARTIST';
export const INSERT_BOOKING_ARTIST_LIST = 'INSERT_BOOKING_ARTIST_LIST';
export const UPDATE_BOOKING_ARTIST = 'UPDATE_BOOKING_ARTIST';
export const UPDATE_BOOKING_ARTIST_LIST = 'UPDATE_BOOKING_ARTIST_LIST';
export const DELETE_BOOKING_ARTIST = 'DELETE_BOOKING_ARTIST';
export const DELETE_BOOKING_ARTIST_LIST = 'DELETE_BOOKING_ARTIST_LIST';
export const LOAD_BOOKING_ARTIST = 'LOAD_BOOKING_ARTIST';




// BOOKING_OVERVIEW Action Types

export const GET_BOOKING_OVERVIEW = 'GET_BOOKING_OVERVIEW';
export const FETCH_BOOKING_OVERVIEW = 'FETCH_BOOKING_OVERVIEW';
export const FETCH_BOOKING_OVERVIEW_INVOICES = 'FETCH_BOOKING_OVERVIEW_INVOICES';
export const SET_BOOKING_OVERVIEW = 'SET_BOOKING_OVERVIEW';
export const INSERT_BOOKING_OVERVIEW = 'INSERT_BOOKING_OVERVIEW';
export const UPDATE_BOOKING_OVERVIEW = 'UPDATE_BOOKING_OVERVIEW';
export const DELETE_BOOKING_OVERVIEW = 'DELETE_BOOKING_OVERVIEW';

// CUSTOM_CHECKLIST Action Types

export const GET_CUSTOM_CHECKLIST = 'GET_CUSTOM_CHECKLIST';
export const FETCH_CUSTOM_CHECKLIST = 'FETCH_CUSTOM_CHECKLIST';
export const SET_CUSTOM_CHECKLIST = 'SET_CUSTOM_CHECKLIST';
export const INSERT_CUSTOM_CHECKLIST = 'INSERT_CUSTOM_CHECKLIST';
export const UPDATE_CUSTOM_CHECKLIST = 'UPDATE_CUSTOM_CHECKLIST';
export const DELETE_CUSTOM_CHECKLIST = 'DELETE_CUSTOM_CHECKLIST';




export const SELECT_BOX = 'SELECT_BOX';
export const MINIMIZE_BOX = 'MINIMIZE_BOX';
export const MAXIMIZE_BOX = 'MAXIMIZE_BOX';
export const PIN_BOX = 'PIN_BOX';



// BOOKING_NOTES Action Types

export const GET_BOOKING_NOTES = 'GET_BOOKING_NOTES';
export const FETCH_BOOKING_NOTES = 'FETCH_BOOKING_NOTES';
export const SET_BOOKING_NOTES = 'SET_BOOKING_NOTES';
export const INSERT_BOOKING_NOTES = 'INSERT_BOOKING_NOTES';
export const UPDATE_BOOKING_NOTES = 'UPDATE_BOOKING_NOTES';
export const DELETE_BOOKING_NOTES = 'DELETE_BOOKING_NOTES';


export const CHECK_CHECKLIST_ITEM = 'CHECK_CHECKLIST_ITEM';
export const UNCHECK_CHECKLIST_ITEM = 'UNCHECK_CHECKLIST_ITEM';
export const TOGGLE_CHECKLIST_ITEM = 'TOGGLE_CHECKLIST_ITEM';
export const SET_CHECKLIST_ITEM = 'SET_CHECKLIST_ITEM';
export const SET_CHECKLIST_ITEM_VALUE = 'SET_CHECKLIST_ITEM_VALUE';
export const SET_CHECKLIST_ITEM_DATASTATE = 'SET_LOADING_CHECKLIST_ITEM';


export const CUSTOM_CHECKLIST_ITEM = createActionTypeModel('CustomChecklistItem');

export const TOGGLE_CUSTOM_CHECKLIST_ITEM = 'TOGGLE_CUSTOM_CHECKLIST_ITEM';
export const SET_CUSTOM_CHECKLIST_ITEM = 'SET_CUSTOM_CHECKLIST_ITEM';
export const SET_CUSTOM_CHECKLIST_ITEM_VALUE = 'SET_CUSTOM_CHECKLIST_ITEM_VALUE';
export const SET_CUSTOM_CHECKLIST_ITEM_DATASTATE = 'SET_CUSTOM_CHECKLIST_ITEM_DATASTATE';


// BOOKING_OFFER_NOTES Action Types

export const GET_BOOKING_OFFER_NOTES = 'GET_BOOKING_OFFER_NOTES';
export const FETCH_BOOKING_OFFER_NOTES = 'FETCH_BOOKING_OFFER_NOTES';
export const SET_BOOKING_OFFER_NOTES = 'SET_BOOKING_OFFER_NOTES';
export const SET_BOOKING_OFFER_NOTES_DATASTATE = 'SET_BOOKING_OFFER_NOTES_DATASTATE';
export const INSERT_BOOKING_OFFER_NOTES = 'INSERT_BOOKING_OFFER_NOTES';
export const UPDATE_BOOKING_OFFER_NOTES = 'UPDATE_BOOKING_OFFER_NOTES';
export const DELETE_BOOKING_OFFER_NOTES = 'DELETE_BOOKING_OFFER_NOTES';



// BOOKING_ARTISTS_STATUS Action Types

export const GET_BOOKING_ARTISTS_STATUS = 'GET_BOOKING_ARTISTS_STATUS';
export const FETCH_BOOKING_ARTISTS_STATUS = 'FETCH_BOOKING_ARTISTS_STATUS';
export const SET_BOOKING_ARTISTS_STATUS = 'SET_BOOKING_ARTISTS_STATUS';
export const SET_BOOKING_ARTISTS_STATUS_DATASTATE = 'SET_BOOKING_ARTISTS_STATUS_DATASTATE';
export const INSERT_BOOKING_ARTISTS_STATUS = 'INSERT_BOOKING_ARTISTS_STATUS';
export const UPDATE_BOOKING_ARTISTS_STATUS = 'UPDATE_BOOKING_ARTISTS_STATUS';
export const DELETE_BOOKING_ARTISTS_STATUS = 'DELETE_BOOKING_ARTISTS_STATUS';


// BOOKING_ARTIST_OFFER_NOTE Action Types

export const GET_BOOKING_ARTIST_OFFER_NOTE = 'GET_BOOKING_ARTIST_OFFER_NOTE';
export const FETCH_BOOKING_ARTIST_OFFER_NOTE = 'FETCH_BOOKING_ARTIST_OFFER_NOTE';
export const SET_BOOKING_ARTIST_OFFER_NOTE = 'SET_BOOKING_ARTIST_OFFER_NOTE';
export const SET_BOOKING_ARTIST_OFFER_NOTE_DATASTATE = 'SET_BOOKING_ARTIST_OFFER_NOTE_DATASTATE';
export const INSERT_BOOKING_ARTIST_OFFER_NOTE = 'INSERT_BOOKING_ARTIST_OFFER_NOTE';
export const UPDATE_BOOKING_ARTIST_OFFER_NOTE = 'UPDATE_BOOKING_ARTIST_OFFER_NOTE';
export const DELETE_BOOKING_ARTIST_OFFER_NOTE = 'DELETE_BOOKING_ARTIST_OFFER_NOTE';



// INVOICE_LINES Action Types

export const GET_INVOICE_LINES = 'GET_INVOICE_LINES';
export const FETCH_INVOICE_LINES = 'FETCH_INVOICE_LINES';
export const SET_INVOICE_LINES = 'SET_INVOICE_LINES';
export const SET_INVOICE_LINES_DATASTATE = 'SET_INVOICE_LINES_DATASTATE';
export const INSERT_INVOICE_LINES = 'INSERT_INVOICE_LINES';
export const UPDATE_INVOICE_LINES = 'UPDATE_INVOICE_LINES';
export const UPDATE_INVOICE_LINES_PRICE = 'UPDATE_INVOICE_LINES_PRICE';
export const UPDATE_INVOICE_LINES_PRICE_TEXT = 'UPDATE_INVOICE_LINES_PRICE_TEXT';
export const DELETE_INVOICE_LINES = 'DELETE_INVOICE_LINES';




// INVOICE_TEXT Action Types

export const GET_INVOICE_TEXT = 'GET_INVOICE_TEXT';
export const FETCH_INVOICE_TEXT = 'FETCH_INVOICE_TEXT';
export const SET_INVOICE_TEXT = 'SET_INVOICE_TEXT';
export const SET_INVOICE_TEXT_DATASTATE = 'SET_INVOICE_TEXT_DATASTATE';
export const INSERT_INVOICE_TEXT = 'INSERT_INVOICE_TEXT';
export const UPDATE_INVOICE_TEXT = 'UPDATE_INVOICE_TEXT';
export const DELETE_INVOICE_TEXT = 'DELETE_INVOICE_TEXT';



export const FETCH_BOOKING_MODULE_INFO = 'FETCH_BOOKING_MODULE_INFO';
export const GET_BOOKING_MODULE_INFO = 'GET_BOOKING_MODULE_INFO';
export const SET_BOOKING_MODULE_INFO = 'SET_BOOKING_MODULE_INFO';

export const SET_SELECTED_MONTHS = 'SET_SELECTED_MONTHS';

// CONTACT_RELATION Action Types

export const GET_CONTACT_RELATION = 'GET_CONTACT_RELATION';
export const FETCH_CONTACT_RELATION = 'FETCH_CONTACT_RELATION';
export const SET_CONTACT_RELATION = 'SET_CONTACT_RELATION';
export const INSERT_CONTACT_RELATION = 'INSERT_CONTACT_RELATION';
export const UPDATE_CONTACT_RELATION = 'UPDATE_CONTACT_RELATION';
export const DELETE_CONTACT_RELATION = 'DELETE_CONTACT_RELATION';



// CONTACT Action Types

export const GET_CONTACT = 'GET_CONTACT';
export const GET_MANY_CONTACTS = 'GET_MANY_CONTACTS';
export const FETCH_CONTACT = 'FETCH_CONTACT';
export const FETCH_MANY_CONTACTS = 'FETCH_MANY_CONTACTS';
export const SET_CONTACT = 'SET_CONTACT';
export const SET_MANY_CONTACTS = 'SET_MANY_CONTACTS';
export const INSERT_CONTACT = 'INSERT_CONTACT';
export const INSERT_MANY_CONTACTS = 'INSERT_MANY_CONTACTS';
export const UPDATE_CONTACT = 'UPDATE_CONTACT';
export const UPDATE_MANY_CONTACTS = 'UPDATE_MANY_CONTACTS';
export const DELETE_CONTACT = 'DELETE_CONTACT';
export const DELETE_MANY_CONTACTS = 'DELETE_MANY_CONTACTS';



// SEND_DOCUMENT_FILES_DATA Action Types

export const GET_SEND_DOCUMENT_FILES_DATA = 'GET_SEND_DOCUMENT_FILES_DATA';
export const FETCH_SEND_DOCUMENT_FILES_DATA = 'FETCH_SEND_DOCUMENT_FILES_DATA';
export const SET_SEND_DOCUMENT_FILES_DATA = 'SET_SEND_DOCUMENT_FILES_DATA';
export const INSERT_SEND_DOCUMENT_FILES_DATA = 'INSERT_SEND_DOCUMENT_FILES_DATA';
export const UPDATE_SEND_DOCUMENT_FILES_DATA = 'UPDATE_SEND_DOCUMENT_FILES_DATA';
export const DELETE_SEND_DOCUMENT_FILES_DATA = 'DELETE_SEND_DOCUMENT_FILES_DATA';




// ITEM_GROUP Action Types

export const GET_ITEM_GROUP = 'GET_ITEM_GROUP';
export const FETCH_ITEM_GROUP = 'FETCH_ITEM_GROUP';
export const SET_ITEM_GROUP = 'SET_ITEM_GROUP';
export const INSERT_ITEM_GROUP = 'INSERT_ITEM_GROUP';
export const UPDATE_ITEM_GROUP = 'UPDATE_ITEM_GROUP';
export const DELETE_ITEM_GROUP = 'DELETE_ITEM_GROUP';


export const ENABLE_ONLINE_AGREEMENT = 'ENABLE_ONLINE_AGREEMENT';
export const GENERATE_DISPLAY_ONLY_DOC = 'GENERATE_DISPLAY_ONLY_DOC';
export const GENERATE_SIGNED_DOCUMENT = 'GENERATE_SIGNED_DOCUMENT';

export const SEND_MAIL_ON_SIGNING_CONTRACT = 'SEND_MAIL_ON_SIGNING_CONTRACT';



export const SET_BOOKING_TAB = 'SET_BOOKING_TAB';

export const TASKS = createActionTypeModel('TASKS');

export const MAXIMIZE_INVOICE_GROUP = 'MAXIMIZE_INVOICE_GROUP';
export const MINIMIZE_INVOICE_GROUP = 'MINIMIZE_INVOICE_GROUP';


// TAX_TYPES Action Types

export const GET_TAX_TYPES = 'GET_TAX_TYPES';
export const FETCH_TAX_TYPES = 'FETCH_TAX_TYPES';
export const SET_TAX_TYPES = 'SET_TAX_TYPES';
export const INSERT_TAX_TYPES = 'INSERT_TAX_TYPES';
export const UPDATE_TAX_TYPES = 'UPDATE_TAX_TYPES';
export const DELETE_TAX_TYPES = 'DELETE_TAX_TYPES';


export const SET_SELECTED_INVOICE_LINE = 'SET_SELECTED_INVOICE_LINE';

export const GET_LOGGED_USER_TASKS = 'GET_LOGGED_USER_TASKS';
export const SET_LOGGED_USER_TASKS = 'SET_LOGGED_USER_TASKS';
export const GET_BOOKING_REQUESTS = 'GET_BOOKING_REQUESTS';
export const SET_BOOKING_REQUESTS = 'SET_BOOKING_REQUESTS';
export const DELETE_BOOKING_REQUEST = 'DELETE_BOOKING_REQUEST';

export const GET_BOOKING_TEMPLATES = 'GET_BOOKING_TEMPLATES';
export const SET_BOOKING_TEMPLATES = 'SET_BOOKING_TEMPLATES';
export const DELETE_BOOKING_TEMPLATE = 'DELETE_BOOKING_TEMPLATE';
export const ADD_BOOKING_TEMPLATE = 'ADD_BOOKING_TEMPLATE';

// FILTER Action Types

export const GET_FILTER = 'GET_FILTER';
export const FETCH_FILTER = 'FETCH_FILTER';
export const SET_FILTER = 'SET_FILTER';
export const RESET_FILTER = 'RESET_FILTER';
export const INSERT_FILTER = 'INSERT_FILTER';
export const UPDATE_FILTER = 'UPDATE_FILTER';
export const DELETE_FILTER = 'DELETE_FILTER';


export const BOOKING_LIST_FILTER = 'BOOKING_LIST_FILTER';

// export const CALENDAR_FILTER='CALENDAR_FILTER';

export const CALENDAR_FILTER = createActionTypeModel('CALENDAR_FILTER');
export const CALENDAR_BOOKING_LIST = createActionTypeModel('CALENDAR_BOOKING_LIST');


// EXTERNAL_CALENDAR_DATES Action Types

export const GET_EXTERNAL_CALENDAR_DATES = 'GET_EXTERNAL_CALENDAR_DATES';
export const FETCH_EXTERNAL_CALENDAR_DATES = 'FETCH_EXTERNAL_CALENDAR_DATES';
export const SET_EXTERNAL_CALENDAR_DATES = 'SET_EXTERNAL_CALENDAR_DATES';
export const INSERT_EXTERNAL_CALENDAR_DATES = 'INSERT_EXTERNAL_CALENDAR_DATES';
export const UPDATE_EXTERNAL_CALENDAR_DATES = 'UPDATE_EXTERNAL_CALENDAR_DATES';
export const DELETE_EXTERNAL_CALENDAR_DATES = 'DELETE_EXTERNAL_CALENDAR_DATES';


export const SET_USERS = 'SET_USERS';


// ARTIST_FIELD Action Types

export const GET_ARTIST_FIELD = 'GET_ARTIST_FIELD';
export const FETCH_ARTIST_FIELD = 'FETCH_ARTIST_FIELD';
export const SET_ARTIST_FIELD = 'SET_ARTIST_FIELD';
export const INSERT_ARTIST_FIELD = 'INSERT_ARTIST_FIELD';
export const UPDATE_ARTIST_FIELD = 'UPDATE_ARTIST_FIELD';
export const DELETE_ARTIST_FIELD = 'DELETE_ARTIST_FIELD';



// EVENT_DETAILS Action Types

export const GET_EVENT_DETAILS = 'GET_EVENT_DETAILS';
export const FETCH_EVENT_DETAILS = 'FETCH_EVENT_DETAILS';
export const SET_EVENT_DETAILS = 'SET_EVENT_DETAILS';
export const SET_EVENT_DETAILS_DATASTATE = 'SET_EVENT_DETAILS_DATASTATE';
export const INSERT_EVENT_DETAILS = 'INSERT_EVENT_DETAILS';
export const UPDATE_EVENT_DETAILS = 'UPDATE_EVENT_DETAILS';
export const DELETE_EVENT_DETAILS = 'DELETE_EVENT_DETAILS';


// This Artist represents the booking overview Artists
export const BookingArtist = createActionTypeModel('BOOKING_ARTIST');



// PERFORMANCE_TYPE Action Types

export const GET_PERFORMANCE_TYPE = 'GET_PERFORMANCE_TYPE';
export const FETCH_PERFORMANCE_TYPE = 'FETCH_PERFORMANCE_TYPE';
export const SET_PERFORMANCE_TYPE = 'SET_PERFORMANCE_TYPE';
export const INSERT_PERFORMANCE_TYPE = 'INSERT_PERFORMANCE_TYPE';
export const UPDATE_PERFORMANCE_TYPE = 'UPDATE_PERFORMANCE_TYPE';
export const DELETE_PERFORMANCE_TYPE = 'DELETE_PERFORMANCE_TYPE';


// SOUNDCHECK Action Types

export const GET_SOUNDCHECK = 'GET_SOUNDCHECK';
export const FETCH_SOUNDCHECK = 'FETCH_SOUNDCHECK';
export const SET_SOUNDCHECK = 'SET_SOUNDCHECK';
export const INSERT_SOUNDCHECK = 'INSERT_SOUNDCHECK';
export const UPDATE_SOUNDCHECK = 'UPDATE_SOUNDCHECK';
export const DELETE_SOUNDCHECK = 'DELETE_SOUNDCHECK';



// STAGE_TIME Action Types

export const GET_STAGE_TIME = 'GET_STAGE_TIME';
export const FETCH_STAGE_TIME = 'FETCH_STAGE_TIME';
export const SET_STAGE_TIME = 'SET_STAGE_TIME';
export const INSERT_STAGE_TIME = 'INSERT_STAGE_TIME';
export const UPDATE_STAGE_TIME = 'UPDATE_STAGE_TIME';
export const DELETE_STAGE_TIME = 'DELETE_STAGE_TIME';


// DURATION Action Types

export const GET_DURATION = 'GET_DURATION';
export const FETCH_DURATION = 'FETCH_DURATION';
export const SET_DURATION = 'SET_DURATION';
export const INSERT_DURATION = 'INSERT_DURATION';
export const UPDATE_DURATION = 'UPDATE_DURATION';
export const DELETE_DURATION = 'DELETE_DURATION';


// STAGE Action Types

export const GET_STAGE = 'GET_STAGE';
export const FETCH_STAGE = 'FETCH_STAGE';
export const SET_STAGE = 'SET_STAGE';
export const INSERT_STAGE = 'INSERT_STAGE';
export const UPDATE_STAGE = 'UPDATE_STAGE';
export const DELETE_STAGE = 'DELETE_STAGE';



// CONFIRMED Action Types

export const GET_CONFIRMED = 'GET_CONFIRMED';
export const FETCH_CONFIRMED = 'FETCH_CONFIRMED';
export const SET_CONFIRMED = 'SET_CONFIRMED';
export const INSERT_CONFIRMED = 'INSERT_CONFIRMED';
export const UPDATE_CONFIRMED = 'UPDATE_CONFIRMED';
export const DELETE_CONFIRMED = 'DELETE_CONFIRMED';



// DOORS_OPEN Action Types

export const GET_DOORS_OPEN = 'GET_DOORS_OPEN';
export const FETCH_DOORS_OPEN = 'FETCH_DOORS_OPEN';
export const SET_DOORS_OPEN = 'SET_DOORS_OPEN';
export const INSERT_DOORS_OPEN = 'INSERT_DOORS_OPEN';
export const UPDATE_DOORS_OPEN = 'UPDATE_DOORS_OPEN';
export const DELETE_DOORS_OPEN = 'DELETE_DOORS_OPEN';



// CURFEW Action Types

export const GET_CURFEW = 'GET_CURFEW';
export const FETCH_CURFEW = 'FETCH_CURFEW';
export const SET_CURFEW = 'SET_CURFEW';
export const INSERT_CURFEW = 'INSERT_CURFEW';
export const UPDATE_CURFEW = 'UPDATE_CURFEW';
export const DELETE_CURFEW = 'DELETE_CURFEW';



// EVENT_URL Action Types

export const GET_EVENT_URL = 'GET_EVENT_URL';
export const FETCH_EVENT_URL = 'FETCH_EVENT_URL';
export const SET_EVENT_URL = 'SET_EVENT_URL';
export const INSERT_EVENT_URL = 'INSERT_EVENT_URL';
export const UPDATE_EVENT_URL = 'UPDATE_EVENT_URL';
export const DELETE_EVENT_URL = 'DELETE_EVENT_URL';


// LINE_UP Action Types

export const GET_LINE_UP = 'GET_LINE_UP';
export const FETCH_LINE_UP = 'FETCH_LINE_UP';
export const SET_LINE_UP = 'SET_LINE_UP';
export const INSERT_LINE_UP = 'INSERT_LINE_UP';
export const UPDATE_LINE_UP = 'UPDATE_LINE_UP';
export const DELETE_LINE_UP = 'DELETE_LINE_UP';


export const UPDATE_CUSTOM_DATA = 'UPDATE_CUSTOM_DATA';
export const SET_CUSTOM_DATA = 'SET_CUSTOM_DATA';




// TRAVEL_DETAILS_STATE Action Types

export const GET_TRAVEL_DETAILS_STATE = 'GET_TRAVEL_DETAILS_STATE';
export const FETCH_TRAVEL_DETAILS_STATE = 'FETCH_TRAVEL_DETAILS_STATE';
export const SET_TRAVEL_DETAILS_STATE = 'SET_TRAVEL_DETAILS_STATE';
export const INSERT_TRAVEL_DETAILS_STATE = 'INSERT_TRAVEL_DETAILS_STATE';
export const UPDATE_TRAVEL_DETAILS_STATE = 'UPDATE_TRAVEL_DETAILS_STATE';
export const DELETE_TRAVEL_DETAILS_STATE = 'DELETE_TRAVEL_DETAILS_STATE';

export const TRAVEL = createActionTypeModel('TRAVEL');


export const GET_FLIGHT_INFO = 'GET_FLIGHT_INFO';



// LOCAL_DETAILS TYPES


export const GET_LOCAL_DETAILS = 'GET_LOCAL_DETAILS';
export const FETCH_LOCAL_DETAILS = 'FETCH_LOCAL_DETAILS';
export const SET_LOCAL_DETAILS = 'SET_LOCAL_DETAILS';
export const INSERT_LOCAL_DETAILS = 'INSERT_LOCAL_DETAILS';
export const UPDATE_LOCAL_DETAILS = 'UPDATE_LOCAL_DETAILS';
export const DELETE_LOCAL_DETAILS = 'DELETE_LOCAL_DETAILS';




// LOCAL_INFO Action Types

export const GET_LOCAL_INFO = 'GET_LOCAL_INFO';
export const FETCH_LOCAL_INFO = 'FETCH_LOCAL_INFO';
export const SET_LOCAL_INFO = 'SET_LOCAL_INFO';
export const INSERT_LOCAL_INFO = 'INSERT_LOCAL_INFO';
export const UPDATE_LOCAL_INFO = 'UPDATE_LOCAL_INFO';
export const DELETE_LOCAL_INFO = 'DELETE_LOCAL_INFO';


export const UPDATE_LOCAL_DETAILS_CONFIRMED_FLAG = 'UPDATE_LOCAL_DETAILS_CONFIRMED_FLAG';
export const SET_LOCAL_DETAILS_CONFIRMED_FLAG = 'SET_LOCAL_DETAILS_CONFIRMED_FLAG';



// CALENDAR_DATE_LOCALS Action Types

export const GET_CALENDAR_DATE_LOCALS = 'GET_CALENDAR_DATE_LOCALS';
export const FETCH_CALENDAR_DATE_LOCALS = 'FETCH_CALENDAR_DATE_LOCALS';
export const SET_CALENDAR_DATE_LOCALS = 'SET_CALENDAR_DATE_LOCALS';
export const INSERT_CALENDAR_DATE_LOCALS = 'INSERT_CALENDAR_DATE_LOCALS';
export const UPDATE_CALENDAR_DATE_LOCALS = 'UPDATE_CALENDAR_DATE_LOCALS';
export const DELETE_CALENDAR_DATE_LOCALS = 'DELETE_CALENDAR_DATE_LOCALS';


export const SHOW_PROMOTER_DEFAULT_NEW = 'SHOW_PROMOTER_DEFAULT_NEW';
export const SAVE_PROMOTER_DEFAULT = 'SAVE_PROMOTER_DEFAULT';

export const PROMOTER_DEFAULT = createActionTypeModel('PROMOTER_DEFAULT');



// RELATION_TYPES Action Types

export const GET_RELATION_TYPES = 'GET_RELATION_TYPES';
export const FETCH_RELATION_TYPES = 'FETCH_RELATION_TYPES';
export const SET_RELATION_TYPES = 'SET_RELATION_TYPES';
export const INSERT_RELATION_TYPES = 'INSERT_RELATION_TYPES';
export const UPDATE_RELATION_TYPES = 'UPDATE_RELATION_TYPES';
export const DELETE_RELATION_TYPES = 'DELETE_RELATION_TYPES';

export const ADD_LOCAL_DETAILS = 'ADD_LOCAL_DETAILS';
export const SAVE_LOCAL_DETAILS = 'SAVE_LOCAL_DETAILS';



// DOCUMENTS TYPES


export const GET_DOCUMENT = 'GET_DOCUMENT';
export const GET_MANY_DOCUMENTS = 'GET_MANY_DOCUMENTS';
export const FETCH_DOCUMENT = 'FETCH_DOCUMENT';
export const FETCH_MANY_DOCUMENTS = 'FETCH_MANY_DOCUMENTS';
export const SET_DOCUMENT = 'SET_DOCUMENT';
export const SET_DOCUMENT_DATASTATE = 'SET_DOCUMENT_DATASTATE';
export const SET_MANY_DOCUMENTS = 'SET_MANY_DOCUMENTS';
export const SET_MANY_DOCUMENTS_DATASTATE = 'SET_MANY_DOCUMENTS_DATASTATE';
export const INSERT_DOCUMENT = 'INSERT_DOCUMENT';
export const INSERT_MANY_DOCUMENTS = 'INSERT_MANY_DOCUMENTS';
export const UPDATE_DOCUMENT = 'UPDATE_DOCUMENT';
export const UPDATE_DOCUMENT_SIGNED_ID = 'UPDATE_DOCUMENT_SIGNED_ID';
export const UPDATE_MANY_DOCUMENTS = 'UPDATE_MANY_DOCUMENTS';
export const DELETE_DOCUMENT = 'DELETE_DOCUMENT';
export const DELETE_MANY_DOCUMENTS = 'DELETE_MANY_DOCUMENTS';


// FILE Action Types

export const GET_FILE = 'GET_FILE';
export const GET_MANY_FILES = 'GET_MANY_FILES';
export const FETCH_FILE = 'FETCH_FILE';
export const FETCH_MANY_FILES = 'FETCH_MANY_FILES';
export const SET_FILE = 'SET_FILE';
export const SET_FILE_DATASTATE = 'SET_FILE_DATASTATE';
export const SET_MANY_FILES = 'SET_MANY_FILES';
export const SET_MANY_FILES_DATASTATE = 'SET_MANY_FILES_DATASTATE';
export const INSERT_FILE = 'INSERT_FILE';
export const INSERT_MANY_FILES = 'INSERT_MANY_FILES';
export const UPDATE_FILE = 'UPDATE_FILE';
export const UPDATE_MANY_FILES = 'UPDATE_MANY_FILES';
export const DELETE_FILE = 'DELETE_FILE';
export const DELETE_MANY_FILES = 'DELETE_MANY_FILES';


export const DOCUMENTS = createActionTypeModel('DOCUMENTS');
export const FILES = createActionTypeModel('FILES');
export const TEMPLATES = createActionTypeModel('TEMPLATE');
export const DOCUMENTDATA = createActionTypeModel('DOCUMENTDATA');

export const DELETE_FILE_RELATION = 'DELETE_FILE_RELATION';








//TODO: CENTRALIZED STORE TYPES ONGOING
// ALL FOLLOWING ACTIONS ARE FOR NESTED BOOKING DETAILS STRUCTURE
// PROCEED CONCURRENTLY WITH THE PREVIOUS ACTIONS - 
// AND REDUCE THE TOP PART TO ZERO 






export const BookingDetails = createActionTypeModel('BookingDetails');
export const BookingDetailsOverview = createActionTypeModel('BookingDetailsOverview');
export const BookingDetailsCustomChecklist = createActionTypeModel('BookingDetailsCustomChecklist');
export const BookingDetailsTaskChecklist = createActionTypeModel('BookingDetailsTaskChecklist');
export const BookingDetailsNewDeals = createActionTypeModel('BookingDetailsNewDeals');
export const BookingDetailsDocuments = createActionTypeModel('BookingDetailsDocuments');
export const BookingDetailsArtistDetails = createActionTypeModel('BookingDetailsArtistDetails');
export const BookingDetailsTravelDetails = createActionTypeModel('BookingDetailsTravelDetails');
export const BookingDetailsLocalDetails = createActionTypeModel('BookingDetailsLocalDetails');
export const BookingDetailsRelationTypes = createActionTypeModel('BookingDetailsLocalDetails');


export const BDArtists = createActionTypeModel('BDArtists');

export const BDCdate = createActionTypeModel('BDCdate');
export const TOGGLE_TDF_FLAG = 'TOGGLE_TDF_FLAG';

export const BDTasks = createActionTypeModel('BDTasks');
export const BDTaskList = createActionTypeModel('BDTaskList');
export const COMPLETE_TASK = 'COMPLETE_TASK';
export const UNDO_TASK = 'UNDO_TASK';

export const BDCustomChecklist = createActionTypeModel('BDCustomChecklist');
export const CHECK_CUSTOM_CHECKLIST_ITEM = 'CHECK_CUSTOM_CHECKLIST_ITEM';
export const UNCHECK_CUSTOM_CHECKLIST_ITEM = 'UNCHECK_CUSTOM_CHECKLIST_ITEM';

export const BDInvoiceline = createActionTypeModel('BDInvoiceline');

export const BDDocumentsData = createActionTypeModel('BDDocumentsData');
export const BDDocuments = createActionTypeModel('BDDocuments');
export const BDFiles = createActionTypeModel('BDFiles');

export const BDFields = createActionTypeModel('BDFields');

export const BDTravels = createActionTypeModel('BDTravels');
export const BDContactRelations = createActionTypeModel('BDContactRelations');

export const BDRelationTypes = createActionTypeModel('BDRelationTypes');
export const BDLocalDetails = createActionTypeModel('BDLocalDetails');

export const SET_DEFAULT_TRAVEL_DETAILS = 'SET_DEFAULT_TRAVEL_DETAILS';



export const UPDATE_CALENDAR_LIST_MONTHS = 'UPDATE_CALENDAR_LIST_MONTHS';